import Vue from 'vue'
import vSelect from 'vue-select'

// Normaliza o texto removendo acentos/diacríticos e convertendo para minúsculo,
// permitindo que a busca ignore acentuação (ex.: "agua" encontra "água").
const normalizeText = value =>
  (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

// Sobrescreve o filtro padrão do vue-select para ignorar acentos na busca de todos os combos.
vSelect.props.filterBy.default = (option, label, search) =>
  normalizeText(label).indexOf(normalizeText(search)) > -1

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: h => h('feather-icon', { props: { size: '14', icon: 'XIcon' } }),
  },
  OpenIndicator: {
    render: h =>
      h('feather-icon', {
        props: { size: '15', icon: 'ChevronDownIcon' },
        class: 'open-indicator',
      }),
  },
})

Vue.component(vSelect)
